import {
    Button,
    Text,
    Modal,
    ModalBody,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    useDisclosure,
    ModalCloseButton,
    HStack,
    Box,
  } from "@chakra-ui/react";
  import React, { ReactNode, useState } from "react";
import { FaTruckMoving } from "react-icons/fa";
import { FiEdit3 } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
  
  interface ModalAlertProps {
    title?: ReactNode; 
    size?: string; 
    body?: ReactNode; 
    footer?: ReactNode;
    buttonLabel?: string; 
    overlayType?: "one" | "two"; 
    isOpen?: boolean; 
    onClose?: () => void; 
    onOpen?: () => void; 
    bg?: string;
    xIsback?: boolean; 
  }
  
  export const ModalAlert: React.FC<ModalAlertProps> = ({
    title = "Modal Title",
    size = "sm",
    body = <Text>Custom backdrop filters!</Text>,
    footer = <Button>OK</Button>,
    buttonLabel = "Open Modal",
    overlayType = "one",
    isOpen: externalIsOpen,
    onClose: externalOnClose,
    onOpen: externalOnOpen,
    bg = "#117baa",
    xIsback
  }) => {
    const nav = useNavigate()
    const OverlayOne = () => (
      <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(10px)" />
    );
  
    const OverlayTwo = () => (
      <ModalOverlay
        bg="none"
        backdropFilter="auto"
        backdropInvert="80%"
        backdropBlur="2px"
      />
    );
  
    const internalDisclosure = useDisclosure();
    const isControlled = externalIsOpen !== undefined;
  
    const isOpen = isControlled ? externalIsOpen : internalDisclosure.isOpen;
    const onOpen = isControlled
      ? externalOnOpen || (() => {})
      : internalDisclosure.onOpen;
    const onClose = isControlled
      ? externalOnClose || (() => {})
      : internalDisclosure.onClose;
  
    const [overlay, setOverlay] = useState(
      overlayType === "one" ? <OverlayOne /> : <OverlayTwo />
    );
  
    return (
      <>
        {!isControlled && (
          <Button
            onClick={() => {
              setOverlay(overlayType === "one" ? <OverlayOne /> : <OverlayTwo />);
              onOpen();
            }}
          >
            {buttonLabel}
          </Button>
        )}
  
        <Modal closeOnOverlayClick={false} isCentered isOpen={isOpen} onClose={onClose} size={size}>
          {overlay}
          <ModalContent borderTopRightRadius={"3xl"}>
            <ModalHeader
              bg={bg}
              color={"white"}
              borderTopRightRadius={"3xl"}
              m={0}
              p={1}
              fontSize={'15px'}
            >
              <HStack justify={'flex-start'}>
                <Box as={FiEdit3} color={bg} boxSize={7} p={1} bg="#DBF2FB" rounded="full" />
                {title}
              </HStack>
            </ModalHeader>
            <ModalCloseButton  size={'sm'} color={'whitesmoke'} border={'1px'} borderRadius={'full'} onClick={() => {
                                                                                                              if (xIsback) {
                                                                                                                nav(-1);
                                                                                                              } else {
                                                                                                                onClose();
                                                                                                              }
                                                                                                            }}
                                                                                                            />
            <ModalBody color={'#117baa'}>{body}</ModalBody>
            <ModalFooter justifyContent={'center'}>
              {footer || <Button onClick={onClose}>Close</Button>}
            </ModalFooter>
          </ModalContent>
        </Modal>
      </>
    );
  };
  